<div
  class="d-flex flex-column justify-content-between flex-grow-1 flex-shrink-1"
  role="document"
  aria-labelledby="confirmation-title"
>
  <div *ngIf="templateSelected === 'confirmContent'">
    <div class="fgbcl-confirmation-header">
      <div class="fgbcl-rewards-purchase-confirmation-title" id="confirmation-title">
        @switch (marketplaceItem.ProcessProviderId) {
          @case (processProviderId.Event) {
            {{ 'events.confirm.message' | translate }}
          }
          @case (processProviderId.VirtualEvent) {
            {{ 'events.confirm.message' | translate }}
          }
          @case (processProviderId.Product) {
            {{ 'products.confirm.message' | translate }}
          }
          @default {
            {{ 'marketplace.confirm.message' | translate }}
          }
        }
      </div>
    </div>

    <div class="fgbcl-confirmation-body">
      <ng-container *fgbWebsiteContentFeatureFlag="'fgbcl.feature.flag.confirmation.additional'">
        <div class="font-size-14 text-black fw-bold rewards-confirmation-additional">
          {{ 'marketplace.confirmation.additional' | translate }}
        </div>
      </ng-container>

      <div class="confirmation-details-section">
        <img
          class="confirm-modal-image"
          src="{{ marketplaceItem.ImageURL | contentImage: '7' : 'marketplace' }}"
          [alt]="marketplaceItem.DisplayName"
          [useDefault]="true"
          [loyaltyType]="'marketplace'"
          draggable="false"
        />

        <div class="fgbcl-confirmation-details">
          <!--Item Name-->
          <div class="purchase-confirmation-name">{{ marketplaceItem.DisplayName }}</div>
          <!--Item Details-->
          @if (selectedAttribute) {
            <div class="confirmation-attribute-values attribute">
              <span class="confirmation-attribute-name mpc-confirmation-spacing">{{ selectedAttribute?.Label }}:</span>
              <span class="confirmation-attribute-value">{{ selectedAttribute.DisplayName }}</span>
            </div>
          }
          <ng-container *ngIf="validCustomFields">
            <ng-container *ngFor="let field of validCustomFields">
              <div *ngIf="field.customFieldValue" class="confirmation-custom-field-values field">
                <span class="confirmation-custom-field-name mpc-confirmation-spacing">{{ field.customFieldName }}:</span>
                <span class="confirmation-custom-field-value">{{ field.customFieldValue }}</span>
              </div>
            </ng-container>
          </ng-container>

          <div class="quantity-value-section">
            <span class="quantity-title mpc-confirmation-spacing font-size-12">{{ 'marketplace.quantity' | translate }}</span>
            <span class="quantity-value">{{ purchaseQuantity }}</span>
          </div>

          <div *ngIf="!marketplaceItem.EcashValue">
            <div id="points-value" class="point-value-section">
              <span class="point-title mpc-confirmation-spacing font-size-12">{{ 'marketplace.points.value' | translate }}</span>
              <span *ngIf="marketplaceItem.PointValue > 0" class="point-value"
                >{{ marketplaceItem.PointValue * purchaseQuantity | number }}
                {{ 'fgbcl.currency.pts' | translate }}
              </span>
              <!--Display text if value is 0-->
              <span *ngIf="marketplaceItem.PointValue == 0" class="point-value"
                >{{ 'fgbcl.marketplace.item.free' | translate }}
              </span>
            </div>
          </div>
          <div *ngIf="marketplaceItem.EcashValue > 0">
            <div id="ecash-value" class="ecash-value-section">
              <span class="ecash-title mpc-confirmation-spacing">{{ 'marketplace.ecash.value' | translate }}</span>
              <span class="ecash-value">{{ (purchaseQuantity * marketplaceItem.EcashValue) / 100 | FortressCurrencyPipe }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="templateSelected === 'confirmContentCardPayment'">
    <p>
      <b>{{ 'marketplace.card.confirm.message' | translate }}</b>
    </p>
    <div class="row">
      <div class="col-6 my-3">
        <label>{{ 'marketplace.quantity' | translate }}</label>
        <span class="material-icons align-middle me-1" aria-hidden="true">shopping_basket</span>
        <span class="text-primary">{{ purchaseQuantity }}</span>
      </div>
      <div class="col-6 my-3">
        <label>{{ 'marketplace.card.merchant.price' | translate }}</label>
        <span class="material-icons align-middle me-1" aria-hidden="true">emoji_events</span>
        <span id="merchant-price" class="text-primary">{{
          (marketplaceItem.MerchantValue / 100) * purchaseQuantity | FortressCurrencyPipe
        }}</span>
      </div>
    </div>
  </div>

  <div class="fgbcl-confirmation-footer">
    <button id="cancel-button" type="button" class="fgbcl-confirmation-button btn btn-purchase-cancel" (click)="modal.close()">
      {{ 'modal.cancel' | translate }}
    </button>
    <button
      id="confirm-button"
      type="button"
      class="fgbcl-confirmation-button btn btn-purchase-confirm"
      [disabled]="isLoading()"
      [attr.aria-busy]="isLoading()"
      [attr.aria-label]="isLoading() ? ('fgbcl.accessibility.loading' | translate) : ('modal.confirm' | translate)"
      (click)="purchase()"
    >
      @if (isLoading()) {
        <fgbcl-loading size="small" />
      } @else {
        {{ 'modal.confirm' | translate }}
      }
    </button>
  </div>
</div>
